import {Routes} from '@angular/router';
import {AuthenticatedOnlyGuard} from '@core/guards/authenticated-only.guard';
import {TermsOfUseGuard} from '@core/components/terms-of-use/guards/terms-of-use-guard';
import {LanguageGuard} from '@core/guards/language.guard';
import {AuthRedirectGuard} from '@core/guards/auth-redirect.guard';
import {MOBILITY_CASE_ROUTES} from "./private/mobility/mobility.routes";

export const APP_ROUTES: Routes = [
	{
		path: '',
		canActivate: [AuthRedirectGuard],
		loadComponent: () => import('./public/public.component').then(c => c.PublicComponent),
		loadChildren: () => import('./public/routes').then(r => r.PUBLIC_ROUTES)
	},
	{
		path: 'app',
		loadComponent: () => import('./private/private.component').then(c => c.PrivateComponent),
		loadChildren: () => import('./private/routes').then(r => r.PRIVATE_ROUTES),
		canActivate: [AuthenticatedOnlyGuard, TermsOfUseGuard],
		canActivateChild: [TermsOfUseGuard]
	},
	{
		path: ':lang',
		canActivate: [LanguageGuard],
		children: [
			{
				path: '',
				canActivate: [AuthRedirectGuard],
				loadComponent: () => import('./public/public.component').then(c => c.PublicComponent),
				loadChildren: () => import('./public/routes').then(r => r.PUBLIC_ROUTES)
			},
			{
				path: 'app',
				loadComponent: () => import('./private/private.component').then(c => c.PrivateComponent),
				loadChildren: () => import('./private/routes').then(r => r.PRIVATE_ROUTES),
				canActivate: [AuthenticatedOnlyGuard, TermsOfUseGuard],
				canActivateChild: [TermsOfUseGuard]
			}
		]
	}
];
